import { MktSpinner } from '@securitize/reactjs-mkt-ui';

export const LoadingPage = () => {
  return (
    <div className="mkt-flex mkt-pb-[80px] wh-m-auto mkt-justify-center mkt-min-h-screen  mkt-items-center">
      <MktSpinner size={'medium'} />
    </div>
  );
};
